module.exports = __webpack_public_path__ + "static/media/impressed-phone.e26eddee.svg";